// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"75f9313b","667":"d862c524","977":"ff130ffe"}[chunkId] + ".chunk.js";
};